var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolioBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360.54mm",
    height: "25.422mm",
    viewBox: "0 0 360.54 25.422",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "7.05715 3.57924",
    result: "turbulence",
    seed: 225,
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "SourceGraphic",
    in2: "turbulence",
    scale: 1.875,
    xChannelSelector: "R",
    yChannelSelector: "G"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -29.922,
    x2: 330.62,
    y1: 113.96,
    y2: 113.96,
    gradientTransform: "translate(-8.0628e-7 -11.888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e11d48",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c31e3f",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e11d48",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.922 -87.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.582 87.918h149.61",
    strokeWidth: 0.365
  }), /*#__PURE__*/React.createElement("rect", {
    x: -29.922,
    y: 90.806,
    width: 360.54,
    height: 22.534,
    fill: "url(#a)",
    filter: "url(#b)",
    strokeWidth: 0.25809
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBanner);
export default __webpack_public_path__ + "static/media/PortfolioBanner.4b9418e0b7cd382904505fbb83b18999.svg";
export { ForwardRef as ReactComponent };